import { z, ZodError } from "zod";
export const zObj = z.object;
export const zArr = z.array;
export const zStr = z.string;
export const zNum = z.number;
export const zBool = z.boolean;
export const zOptional = z.optional;
export const zNullable = z.nullable;
export const zAny = z.any;
export const zRecord = z.record;
export function parsingErrorToString(url, err) {
    let errorMessage = `Error in request: ${url}`;
    if (err instanceof ZodError) {
        errorMessage += `\nThe type validator found an error with the data.`;
        for (const issue of err.issues) {
            errorMessage += `\n${issueToString(issue)}`;
        }
    }
    return errorMessage;
}
export function issueToString(issue) {
    return String(issue);
}
export function toZodError(error) {
    return error;
}
//# sourceMappingURL=zodWrapper.js.map